require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-transformers-attention-in-disguise.json") })
        }
      }, "path---posts-transformers-attention-in-disguise");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-transformers-attention-in-disguise!./.cache/json/posts-transformers-attention-in-disguise.json
// module id = 412
// module chunks = 231608221292675